import MenuTypeSelector from './menu-type-selector';

export default MenuTypeSelector;
